import { FormControlErrorMessageResolver } from '@pva/components-lib';

/* Variante als Map
 * export const globalErrorMessages = [
 *   { required: 'Dieses Feld ist verpflichtend zu belegen.' },
 * ];
 */

/**
 * Variante als Revolver Function
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const globalErrorMessageResolver: FormControlErrorMessageResolver = (errorKey, errorValue, control): string => {
    //Hier können nun anhand des Error Keys und Error Value entsprechende Error Messages gemappt werden.
    switch (errorKey) {
        case 'required':
            return 'Dieses Feld ist verpflichtend zu belegen.';
        case 'invalidRange':
            return 'Das Bis-Datum darf nicht vor dem Von-Datum liegen';
        case 'eingabeUeberpruefen':
            return 'Eingabe überprüfen';
        case 'exactLength':
            return 'Die Eingabe muss ' + errorValue + ' Zeichen lang sein';
        case 'minLength':
            return 'Die minimale Länge des Feldes muss ' + errorValue + ' Zeichen betragen';
        case 'maxLength':
            return 'Die maximale Länge des Feldes darf ' + errorValue + ' Zeichen betragen';
        default:
            return typeof errorValue === 'string' ? errorValue : 'Bitte überprüfen Sie ihre Eingabe.';
    }
};
